import React from "react";
import {
  FaCarSide,
  FaGlobe,
  FaShippingFast,
  FaHandshake,
  FaCheckCircle,
  FaArrowRight,
  FaWhatsapp, 
} from "react-icons/fa";

import "../styles/importGuide.css";
import "../styles/dutycalc.css";
import ImportCalculator from "../components/ImportCalculator";
import { Link } from "react-router-dom";
 
const ImportGuide = () => {
const steps = [
  {
    title: "Tell Us What You Need",
    description:
      "Share your preferred vehicle make, model, year, mileage, and budget. Our team will use your requirements to begin sourcing suitable options."
  },
  {
    title: "Receive Vehicle Options",
    description:
      "We present a selection of verified vehicles from trusted suppliers and auctions, complete with photos, specifications, and pricing."
  },
  {
    title: "Secure Your Vehicle",
    description:
      "Once you select a vehicle, we guide you through payment and purchasing procedures while ensuring all documentation is processed correctly."
  },
  {
    title: "Shipping & Tracking",
    description:
      "Your vehicle is shipped to Kenya and we keep you updated throughout the journey with regular shipment progress reports."
  },
  {
    title: "Customs Clearance",
    description:
      "Our team handles customs procedures, tax assessment, clearance, and compliance requirements to ensure a smooth process."
  },
  {
    title: "Vehicle Delivery",
    description:
      "After clearance and registration, your vehicle is delivered or made available for collection, ready for the road."
  }
];


  return (
    <div className="import-guide-page">
      {/* HERO */}
      <section className="import-hero">
        <div className="import-hero-content">
          <span>Import With Us</span>

          <h1>Import Your Dream Vehicle With Confidence</h1>

          <p>
            We help you source, purchase, ship, clear, and register
            quality vehicles from Japan, the UK, and other global
            markets.
          </p>
         
         <div className="import-btns">
         <a href="#importscalculator" className="primary-btn">
           Imports Duty Calculator
          </a>
          <Link to="/imports" className="primary-btn-2">
            Browse Available Units
          </Link>
         </div>
          
        </div>
      </section>

      {/* WHY IMPORT */}
      <section className="import-benefits">
        <div className="top-header">
          <span>Why Import With Us</span>
          <h2>A Seamless Vehicle Import Experience</h2>
        </div>

        <div className="benefits-grid">
          <div className="benefit-card">
            <FaCarSide />
            <h3>Quality Vehicles</h3>
            <p>
              Carefully sourced vehicles that meet your requirements.
            </p>
          </div>

          <div className="benefit-card">
            <FaGlobe />
            <h3>Global Sourcing</h3>
            <p>
              Access vehicles from trusted international markets.
            </p>
          </div>

          <div className="benefit-card">
            <FaShippingFast />
            <h3>End-To-End Support</h3>
            <p>
              We handle shipping, clearance and registration.
            </p>
          </div>

          <div className="benefit-card">
            <FaHandshake />
            <h3>Transparent Pricing</h3>
            <p>
              No hidden costs. Everything is communicated upfront.
            </p>
          </div>
        </div>
      </section>


      <section id="importscalculator">
      <ImportCalculator/>
      </section>
      

    <section className="tax-breakdown">
      <div className="top-header">
        <span>Understanding Import Costs</span>
        <h2>The Total Cost Of Importing A Vehicle in Kenya?</h2>
      </div>

      <div className="tax-grid">

  <div className="tax-card">
    <div className="tax-card-header">
      <FaCheckCircle className="tax-card-icon" />
      <h3>Vehicle Purchase Price</h3>
    </div>

    <p>
      This is the amount paid to purchase the vehicle from an auction,
      dealership, or supplier abroad. It forms the foundation of your
      overall import budget.
    </p>
  </div>

  <div className="tax-card">
    <div className="tax-card-header">
      <FaCheckCircle className="tax-card-icon" />
      <h3>Freight & Shipping</h3>
    </div>

    <p>
      Shipping charges cover transportation from the country of origin
      to the port of Mombasa. Costs vary depending on the vehicle type,
      shipping method, and departure location.
    </p>
  </div>

  <div className="tax-card">
    <div className="tax-card-header">
      <FaCheckCircle className="tax-card-icon" />
      <h3>Marine Insurance</h3>
    </div>

    <p>
      Insurance protects the vehicle while in transit and is usually
      included when determining the CIF value used for duty assessment.
    </p>
  </div>

  <div className="tax-card">
    <div className="tax-card-header">
      <FaCheckCircle className="tax-card-icon" />
      <h3>CIF Value</h3>
    </div>

    <p>
      CIF stands for Cost, Insurance, and Freight. This combined value
      serves as the primary basis for calculating import taxes and duties.
    </p>
  </div>

  <div className="tax-card">
    <div className="tax-card-header">
      <FaCheckCircle className="tax-card-icon" />
      <h3>Import Duty (25%)</h3>
    </div>

    <p>
      Import Duty is charged on the CIF value and represents one of the
      key statutory charges payable before a vehicle can be cleared.
    </p>
  </div>

  <div className="tax-card">
    <div className="tax-card-header">
      <FaCheckCircle className="tax-card-icon" />
      <h3>Excise Duty</h3>
    </div>

    <p>
      Excise Duty depends on engine capacity and vehicle classification.
      Higher-capacity vehicles generally attract higher excise rates.
    </p>
  </div>

  <div className="tax-card">
    <div className="tax-card-header">
      <FaCheckCircle className="tax-card-icon" />
      <h3>Import Declaration Fee (IDF)</h3>
    </div>

    <p>
      IDF is charged on imported goods entering Kenya and contributes to
      the total customs charges payable during clearance.
    </p>
  </div>

  <div className="tax-card">
    <div className="tax-card-header">
      <FaCheckCircle className="tax-card-icon" />
      <h3>Railway Development Levy (RDL)</h3>
    </div>

    <p>
      RDL is a statutory levy charged on imports and supports the
      development of national transport infrastructure.
    </p>
  </div>

  <div className="tax-card">
    <div className="tax-card-header">
      <FaCheckCircle className="tax-card-icon" />
      <h3>Value Added Tax (VAT)</h3>
    </div>

    <p>
      VAT is calculated after combining the CIF value with applicable
      duties and levies, making it one of the largest components of the
      total import cost.
    </p>
  </div>

  <div className="tax-card">
    <div className="tax-card-header">
      <FaCheckCircle className="tax-card-icon" />
      <h3>Customs Clearance & Documentation</h3>
    </div>

    <p>
      Professional clearance services help process customs requirements,
      documentation, inspections, and release procedures at the port.
    </p>
  </div>

  <div className="tax-card">
    <div className="tax-card-header">
      <FaCheckCircle className="tax-card-icon" />
      <h3>Inland Transportation</h3>
    </div>

    <p>
      Once cleared, the vehicle is transported from the port to your
      preferred destination within Kenya.
    </p>
  </div>

  <div className="tax-card">
    <div className="tax-card-header">
      <FaCheckCircle className="tax-card-icon" />
      <h3>Registration & Number Plates</h3>
    </div>

    <p>
      Before the vehicle can legally operate on Kenyan roads, it must
      undergo registration and be issued with number plates and logbook
      documentation.
    </p>
  </div>

</div>

     
    </section>
      {/* PROCESS */}
      <section className="import-process">
        <div className="top-header">
          <span>How It Works</span>
          <h2>Our Import Process</h2>
        </div>

       <div className="timeline">
  {steps.map((step, index) => (
    <div className="timeline-content" key={index}>
      <span className="timeline-card-number">
        {String(index + 1).padStart(2, "0")}
      </span>

      <h3>{step.title}</h3>
      <p>{step.description}</p>
    </div>
  ))}
</div>
      </section>
 

      {/* CTA */}
      <section className="import-cta-wrapper">
  <div className="import-cta">
    <h2>Ready To Import Your Dream Car?</h2>

    <p>
      Start your import journey today with a trusted partner
      that handles everything from sourcing to delivery.
    </p>

    <div className="cta-actions">
       <a
        href="https://wa.me/254713988888?text=Hello%20Matel%20Trading%20Motors,%20I%20would%20like%20to%20import%20a%20vehicle.%20Please%20assist%20me%20with%20the%20process."
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp__btn"
      >
        <FaWhatsapp />
         WhatsApp Us
      </a>
      <Link to="/imports" className="cta-btn">
        Browse Available Units
        <FaArrowRight />
      </Link>

     
    </div>
  </div>
</section>
      
    </div>
  );
};

export default ImportGuide;